import { fabric } from 'fabric';

// Adapted from here https://jsfiddle.net/krunalhshah/qcqa1oe9/
// Extending Fabric line class (https://developer.tizen.org/community/tip-tech/creating-custom-objects-fabric.js)
const LineWithArrow = fabric.util.createClass(fabric.Line, {
  type: 'line_with_arrow',

  initialize(element, options) {
    options || (options = {});
    this.callSuper('initialize', element, options);

    // Set default options
    this.set({
      objectCaching: false, // Needed to prevent artefacts https://stackoverflow.com/questions/48567482/fabricjs-tips-of-arrows-rendering-with-artefacts-when-being-dragged
      hasBorders: false,
      hasControls: false,
    });
  },

  _render(ctx) {
    this.callSuper('_render', ctx);
    ctx.save();
    const xDiff = this.x2 - this.x1;
    const yDiff = this.y2 - this.y1;
    const angle = Math.atan2(yDiff, xDiff);
    ctx.translate((this.x2 - this.x1) / 2, (this.y2 - this.y1) / 2);
    ctx.rotate(angle);
    ctx.beginPath();
    // Move 5px in front of line to start the arrow so it does not have the square line end showing in front (0,0)
    ctx.moveTo(5, 0);
    ctx.lineTo(-5, 5);
    ctx.lineTo(-5, -5);
    ctx.closePath();
    ctx.fillStyle = this.stroke;
    ctx.fill();
    ctx.restore();
  },

  toObject() {
    return fabric.util.object.extend(this.callSuper('toObject'), {
      customProps: this.customProps,
    });
  },
});

export default LineWithArrow;



// WEBPACK FOOTER //
// ./library/app/components/Diagram/Items/LegacyLineWithArrow.js